/**
 * Wire → view mappers. The raw snake_case `WellOut` from Oxbo-M is normalized
 * to a camelCase `WellView` so the whole UI works in one clean shape and the
 * finder can group/filter without touching wire field names.
 */
import type { WellOut } from "./types";

export interface WellView {
  id: string;
  uwi: string;
  commonName: string;
  api14: string | null;
  basin: string;
  field: string;
  pad: string;
  operator: string;
  status: string;
  isActive: boolean;
}

/** Normalize a raw Oxbo-M well to the view shape (never returns null fields). */
export function toWellView(raw: WellOut): WellView {
  return {
    id: raw.id,
    uwi: raw.uwi,
    commonName: raw.common_name,
    api14: raw.api14,
    basin: raw.basin ?? "—",
    field: raw.field ?? "—",
    pad: raw.pad ?? "—",
    operator: raw.operator ?? "—",
    status: raw.status ?? "—",
    isActive: raw.is_active,
  };
}
